export type InformNotePart = {
    text: string
    emphasize: boolean
}

const EMPHASIS = /(ВСЕХ|ВСЕ)(?![А-ЯЁа-яё])/g

export function parseInformNoteParts(raw: string): InformNotePart[] {
    const cleaned = String(raw || '').trim()
    if (!cleaned) {
        return []
    }
    return cleaned
        .split(EMPHASIS)
        .filter((part) => part !== '')
        .map((part) => ({
            text: part,
            emphasize: part === 'ВСЕ' || part === 'ВСЕХ',
        }))
}
